import {BlockType, Blocks} from '../blocks/Blocks'
import {
	Contentside,
	ContentsideContent,
	ContentsideSidebar
} from '../layout/Contentside'
import {EntryData, PageData} from '../../types'
import {Hero, HeroSide, HeroType} from '../layout/Hero'
import {SidebarBlockType, SidebarBlocks} from '../sidebar/SidebarBlocks'

import {Breadcrumbs} from '../layout/Breadcrumbs'
import {CountryType} from '../layout/worldmap/RegionSelector'
import {Layout} from '../layout/Layout'
import React from 'react'
import {RelatedProjects} from '../layout/RelatedProjects'
import {SidebarCountry} from '../layout/SidebarCountry'
import {ThemePageType} from '../layout/worldmap/Themes'
import {style} from 'util/style'
import {wrap} from '@codeurs/front'

const styles = style('projectdetail')

export type ProjectDetailType = {
	relatedCountries: Array<CountryType>
	primary_country: CountryType
	continent: EntryData
	themes: Array<ThemePageType>
	related_projects: Array<ProjectDetailType>
}

type SidebarpageType = {
	hero: HeroType
	contentblocks?: Array<BlockType>
	sidebarblocks?: Array<SidebarBlockType>
	blocks?: Array<BlockType>
}

export const ProjectDetail: React.FC<
	PageData & SidebarpageType & ProjectDetailType
> = wrap(Layout)(({...props}) => {
	const {
		parents,
		title,
		hero,
		contentblocks,
		sidebarblocks,
		blocks,
		primary_country: primaryCountry,
		continent,
		themes,
		related_projects
	} = props
	const hasContentside =
		(hero && !hero?.image) ||
		(contentblocks && contentblocks.length > 0) ||
		(sidebarblocks && sidebarblocks.length > 0)

	return (
		<div className={styles()}>
			{hero?.image && <Hero {...hero} title={(hero && hero.title) || title} />}
			<Breadcrumbs parents={parents} title={title} />
			<Contentside>
				<ContentsideContent>
					{(!hero || !hero?.image) && (
						<HeroSide {...hero} title={hero?.title || title} />
					)}
					{hasContentside && <Blocks blocks={contentblocks} />}
				</ContentsideContent>
				<ContentsideSidebar>
					<SidebarCountry
						country={primaryCountry}
						continent={continent?.title}
						themes={themes}
					/>
					{hasContentside && <SidebarBlocks blocks={sidebarblocks} />}
				</ContentsideSidebar>
			</Contentside>
			<Blocks blocks={blocks} container={true} />
			<RelatedProjects items={related_projects} />
		</div>
	)
})
